'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { fromJS, Map as ImmutableMap } from 'immutable';
import { beginningOfTime, now, toMoment } from 'UIComponents/core/SimpleDate';
import * as FILTERS from '../constants/reportFilters';
import { getIsUngatedToUnusedReportsFilter } from './gatesSelector';
const selectRoot = get('reports');
export const selectReport = createSelector([selectRoot], root => get('report', root));
export const selectReportCount = createSelector([selectRoot], root => getIn(['reports', 'total'], root));
export const selectSavedReports = createSelector([selectRoot], root => getIn(['reports', 'reports'], root));
export const selectSavedReportsView = createSelector([selectRoot], root => getIn(['reports', 'view'], root));
export const selectReportTemplates = createSelector([selectRoot], root => getIn(['templateResults', 'templates'], root));
export const selectTemplatesLimit = createSelector([selectRoot], root => getIn(['templateResults', 'limit'], root));
export const selectRestorableReports = createSelector([selectRoot], root => getIn(['restorableReports', 'reports'], root));
export const selectReportsRequestStatus = createSelector([selectRoot], root => getIn(['status', 'getSavedReports'], root));
export const selectGetReportRequestStatus = createSelector([selectRoot], root => getIn(['status', 'getReport'], root));
export const selectReportTemplatesStatus = createSelector([selectRoot], root => getIn(['status', 'getReportTemplateSearchResults'], root));
export const selectRestorableReportsRequestStatus = createSelector([selectRoot], root => getIn(['status', 'getRestorableReports'], root));
export const selectAiSearchRequestStatus = createSelector([selectRoot], root => getIn(['status', 'getAiSearch'], root));
export const selectFilters = createSelector([selectRoot], root => get('filters', root));
export const selectSearchFilter = createSelector([selectRoot], root => getIn(['filters', 'filterSearch'], root));
export const selectAiSearchResponse = createSelector([selectRoot], root => getIn(['aiTemplateResults', 'searchResponse'], root));
const getDate = dateObj => {
  const date = dateObj === null || dateObj === void 0 ? void 0 : dateObj.get('date');
  if (!date) {
    return null;
  }
  return toMoment(ImmutableMap.isMap(date) ? date.toJS() : date).startOf('day').valueOf();
};
const getStartDate = date => {
  const startDate = date.get('startDate');
  if (!startDate) {
    return toMoment(beginningOfTime()).valueOf();
  }
  return toMoment(ImmutableMap.isMap(startDate) ? startDate.toJS() : startDate).startOf('day').valueOf();
};
const getEndDate = date => {
  const endDate = date.get('endDate');
  if (!endDate) {
    return toMoment(now()).endOf('day').valueOf();
  }
  return toMoment(ImmutableMap.isMap(endDate) ? endDate.toJS() : endDate).endOf('day').valueOf();
};
const normalizeParameters = options => {
  return fromJS(options).filter(val => val !== null && val !== undefined && val !== '' && val !== 'ALL').toJS();
};
export const selectQueryFilters = state => {
  const filters = selectFilters(state);
  const hasUnusedReportsFilter = getIsUngatedToUnusedReportsFilter(state);
  return normalizeParameters({
    limit: filters.get('limit'),
    offset: filters.get('offset'),
    sortBy: filters.get('sortColumn'),
    sortOrder: filters.get('sortDirection'),
    search: filters.get(FILTERS.SEARCH),
    reportOwnerId: filters.get(FILTERS.OWNED_BY),
    dashboardId: filters.get(FILTERS.DASHBOARD_ID),
    inDashboard: filters.get(FILTERS.IN_DASHBOARD),
    customReports: filters.get(FILTERS.CUSTOM_REPORTS),
    favorite: filters.get(FILTERS.FAVORITES),
    updatedAtStartDate: getStartDate(filters.get(FILTERS.UPDATED_AT)),
    updatedAtEndDate: getEndDate(filters.get(FILTERS.UPDATED_AT)),
    lastViewedAt: getDate(filters.get(FILTERS.LAST_VIEWED_AT)),
    accessClassification: filters.get(FILTERS.ASSIGNED),
    businessUnitId: filters.get(FILTERS.BUSINESS_UNIT),
    unused: hasUnusedReportsFilter ? filters.get(FILTERS.UNUSED) : undefined // not actually a supported param in regular /get reports endpoint
  });
};
export const selectFilteredReportCount = createSelector([selectRoot], root => get('filteredReportCount', root));
export const selectIsUnusedFilterActive = createSelector([selectFilters, getIsUngatedToUnusedReportsFilter], (filters, isUngatedToUnusedFilter) => {
  return isUngatedToUnusedFilter && filters.get(FILTERS.UNUSED) === 'true';
});